import SearchLocation from './search-location';
export default SearchLocation;